import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Tooltip } from "@mui/material";
import axios from "../../../../../utils/axios";
import {
  BatteryIcon,
  DeleteIcon,
  ReportIcon,
  WifiIcon,
} from "../../../../icons/StatusIcons";

const Devicelevel = ({ deviceDetail, id, reportlink }) => {
  const navigate = useNavigate();
  const handleDeleteDevice = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          axios
            .post("delete/device", {
              id,
            })
            .then(async () => {
              await Swal.fire({
                title: "Success",
                text: "Device successfully deleted",
                icon: "success",
              });

              navigate("/device-listing");
            });
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  return (
    <div className="flow-detail-wrap d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center flow-card-data">
        <div className="me-180">
          <h1 className="flow-detail">
            {deviceDetail?.flow}
            {deviceDetail?.unit ? <span>({deviceDetail.unit})</span> : null}
          </h1>
          <p className="flow-type text-start">
            {deviceDetail?.deviceType === "flow"
              ? "Current Flow"
              : "Current Level"}
          </p>
        </div>
        {deviceDetail?.deviceType === "flow" && (
          <div>
            <h1 className="flow-detail">
              {deviceDetail?.totalFlow}
              {deviceDetail?.totalUnit ? (
                <span>({deviceDetail.totalUnit})</span>
              ) : null}
            </h1>
            <p className="flow-type text-start">
              {" "}
              {deviceDetail?.deviceType === "flow"
                ? "Total Flow"
                : "Total Level"}
            </p>
          </div>
        )}
      </div>

      <div className="device-action status-icon-row">
        <button
          type="button"
          className="btn-action"
          onClick={handleDeleteDevice}
          aria-label="Delete device"
        >
          <DeleteIcon size="lg" />
        </button>
        <WifiIcon
          size="lg"
          connected={deviceDetail?.networkStatus === 1}
        />
        <Tooltip
          title={deviceDetail?.battery === 1 ? "Power On" : "Power Off"}
        >
          <BatteryIcon size="lg" on={deviceDetail?.battery === 1} />
        </Tooltip>
        <Link to={reportlink} className="btn-action" aria-label="Open report">
          <ReportIcon size="lg" />
        </Link>
      </div>
    </div>
  );
};

export default Devicelevel;
